import { render, staticRenderFns } from "./WolFramWidget.vue?vue&type=template&id=d95337b6&scoped=true"
import script from "./WolFramWidget.vue?vue&type=script&lang=js"
export * from "./WolFramWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95337b6",
  null
  
)

export default component.exports